// Switches the product tabs in the "Деталі набору" section. Every panel is already in the page,
// so a tab only toggles visibility. A custom element rather than an inline script, so it also runs
// where the markup is injected.
class SetDetailsTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.set-details__tab'));
    this.panels = Array.from(this.querySelectorAll('.set-details__panel'));
    if (!this.tabs.length) return;

    this.onClick = (event) => {
      const tab = event.target.closest('.set-details__tab');
      if (tab) this.select(this.tabs.indexOf(tab));
    };
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  select(index) {
    if (index < 0) return;
    this.tabs.forEach((tab, i) => tab.setAttribute('aria-selected', i === index));
    this.panels.forEach((panel, i) => panel.toggleAttribute('hidden', i !== index));
  }
}

if (!customElements.get('set-details-tabs')) {
  customElements.define('set-details-tabs', SetDetailsTabs);
}
